import { useState } from "react";
import { ArrowRight, Check, Loader2 } from "lucide-react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "https://api.relio.in";
const API = `${BACKEND_URL}/api`;

export default function WaitlistForm({ variant = "inline", onSuccess }) {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle"); // idle | loading | success | error
  const [errorMsg, setErrorMsg] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setErrorMsg("Please enter a valid email.");
      setStatus("error");
      return;
    }

    setStatus("loading");
    setErrorMsg("");

    try {
      await axios.post(`${API}/waitlist`, { email: email.trim() });
      setStatus("success");
      if (onSuccess) onSuccess(email.trim());
    } catch {
      setErrorMsg("Something went wrong. Try again.");
      setStatus("error");
    }
  };

  if (status === "success") {
    return (
      <div
        data-testid="waitlist-success"
        className={`flex items-center gap-2 ${
          variant === "modal" ? "justify-center py-4" : ""
        }`}
      >
        <div className="w-6 h-6 rounded-full bg-green-500/10 flex items-center justify-center">
          <Check size={14} className="text-green-600" />
        </div>
        <span className="text-sm font-medium text-[#1c1b1d]">
          You're on the list! We'll be in touch.
        </span>
      </div>
    );
  }

  return (
    <form
      data-testid="waitlist-form"
      onSubmit={handleSubmit}
      className={`
        flex gap-2
        ${variant === "modal" ? "flex-col" : "flex-row items-center"}
      `}
    >
      <div className="relative flex-1">
        <input
          data-testid="waitlist-email-input"
          type="email"
          value={email}
          onChange={(e) => {
            setEmail(e.target.value);
            if (status === "error") setStatus("idle");
          }}
          placeholder="you@company.com"
          className={`
            w-full bg-white rounded-xl px-4 py-3 text-sm text-[#1c1b1d] 
            placeholder:text-[#e2bfb2] focus:outline-none focus:ring-1 focus:ring-[#a33900] transition-all
            ${status === "error" ? "ring-1 ring-red-400" : ""}
          `}
          style={{ border: "1px solid rgba(226, 191, 178, 0.2)" }}
        />
        {status === "error" && errorMsg && (
          <p className="text-xs text-red-500 mt-1 absolute -bottom-5 left-0">
            {errorMsg}
          </p>
        )}
      </div>
      <button
        data-testid="waitlist-submit-button"
        type="submit"
        disabled={status === "loading"}
        className="cta-gradient text-white rounded-xl px-5 py-3 font-medium text-sm shadow-[0_8px_20px_rgba(204,73,0,0.25)] transition-transform hover:-translate-y-0.5 disabled:opacity-60 inline-flex items-center gap-2 whitespace-nowrap"
      >
        {status === "loading" ? (
          <Loader2 size={14} className="animate-spin" />
        ) : (
          <>
            Join Waitlist
            <ArrowRight size={14} />
          </>
        )}
      </button>
    </form>
  );
}
